import { render, staticRenderFns } from "./commonPagination.vue?vue&type=template&id=59ed4501&scoped=true"
import script from "./commonPagination.vue?vue&type=script&lang=js"
export * from "./commonPagination.vue?vue&type=script&lang=js"
import style0 from "./commonPagination.vue?vue&type=style&index=0&id=59ed4501&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed4501",
  null
  
)

export default component.exports